<script>
  import { settingsStore } from '../stores/settingsStore.js';

  const { error, success } = settingsStore;
</script>

{#if $error}
  <div class="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded">
    {$error}
  </div>
{/if}

{#if $success}
  <div class="mb-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded">
    {$success}
  </div>
{/if}
